const MuiStack = {};
export { MuiStack };

//# sourceMappingURL=stack-overrides.js.map